import { number, string } from 'yup';

import { INSTALLED_STATUSES } from 'src/constants/mx/installed-status';

export const getValidationSchema = () => ({
  part_number_removed: string(),
  part_number_installed: string(),
  serial_number_removed: string(),
  serial_number_installed: string(),
  removal_reason: number(),
  installed_status: number().oneOf(Object.values(INSTALLED_STATUSES)),
});
